module.exports = __webpack_public_path__ + "img/registe_info_message_dialog.aded2ccd.png";